import { call } from 'redux-saga/effects';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { PredictiveModelCard } from '~src/predictiveModel/components/cardView/PredictiveModelCard';
import { PredictiveModels } from '~src/predictiveModel/resources/PredictiveModels';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ContentTypeFilterClause,MixedContentItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { PredictiveModelContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { getPredictiveModelInfos } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { getGenericDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const PredictiveModelDefinition: MixedContentItemDefinition & SpaceDefinition<'predictiveModel'> = {
  itemType: 'predictiveModel',
  contentType: 'predictiveModel',
  singularName: Messages.predictiveModel,
  pluralName: Messages.predictiveModels,
  emptyStateMessage: Messages.predictiveModelsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_PredictiveModels,
  contentFilterKeys: PredictiveModelContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: PredictiveModelCard,
  listViewIconUrl: PredictiveModels.getPredictiveModelsIconPath(false),
  filterClause: ServerFilterClauses.ContentType(['predictiveModel']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.predictiveModelUrl(contentId),
  getBasicQuery: () => {
    return PredictiveModels.all().withExtraParams(PredictiveModelContentType.extraQueryParams);
  },
  fieldValueResourceType: 'predictiveModel',
  getContentInfo: (contentList: IContentInfo[]) => call(getPredictiveModelInfos, contentList),
  supportedDisplayModes: ['list', 'thumbnail'],
  headerIconPath: (contentInfo) => PredictiveModels.getPredictiveModelsIconPath(),
};
